<script setup></script>

<template>
  <main class="bg-gray-100 text-gray-500 min-h-screen">
    <header class="sticky top-0 z-40 border-b border-slate-200/80 bg-white/90 backdrop-blur">
      <div class="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
        <router-link :to="{ name: 'home' }" class="text-sm md:text-base font-semibold text-slate-800">
          Untracked Apps
        </router-link>
        <nav class="flex items-center gap-3 md:gap-5 text-sm md:text-base">
          <router-link :to="{ name: 'products' }" class="text-slate-700 hover:text-blue-700">Products</router-link>
          <router-link :to="{ name: 'support' }" class="text-slate-700 hover:text-blue-700">Support</router-link>
          <router-link :to="{ name: 'privacy' }" class="text-slate-700 hover:text-blue-700">Privacy</router-link>
          <router-link :to="{ name: 'terms' }" class="text-slate-700 hover:text-blue-700">Terms</router-link>
        </nav>
      </div>
    </header>
    <slot></slot>
    <footer class="text-center py-10 text-sm text-gray-500 space-y-2">
      <p>&copy; {{ new Date().getFullYear() }} Untracked Apps. All rights reserved.</p>
      <p class="text-base">
        Need app support?
        <a href="mailto:support@untrackedapps.com" class="text-blue-600 hover:underline">support@untrackedapps.com</a>
      </p>
      <p class="space-x-4">
        <router-link :to="{ name: 'products' }" class="text-blue-600 hover:underline">Our Products</router-link>
        <span>·</span>
        <router-link :to="{ name: 'support' }" class="text-blue-600 hover:underline">Support</router-link>
        <span>·</span>
        <router-link :to="{ name: 'privacy' }" class="text-blue-600 hover:underline">Privacy Policy</router-link>
        <span>·</span>
        <router-link :to="{ name: 'terms' }" class="text-blue-600 hover:underline">Terms of Use</router-link>
      </p>
    </footer>
  </main>
</template>

<style scoped></style>
